/**
 * * using this hook to reuse the modal context declaration.
 */

import { useContext } from "react";
import { IModalContext, ModalContext } from "../context/ModalContext";

/**
 * @function useModal
 * @description Hook to reuse modal context declaration logic
 * @returns ModalContext
 */
const useModal: () => IModalContext = () => {
  const Modal = useContext(ModalContext);
  return { ...Modal };
};

export default useModal;
